import { render, staticRenderFns } from "./PlanModal.vue?vue&type=template&id=23a27fe3&"
import script from "./PlanModal.vue?vue&type=script&lang=js&"
export * from "./PlanModal.vue?vue&type=script&lang=js&"
import style0 from "./PlanModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports